import { buildResourcePath } from '@/utils'
import avatar from '@/assets/images/avatar.png'
export default {
  filters: {
    avatar: function(input) {
      return buildResourcePath(input) || avatar
    }
  }
}